<app-header [label]="'AI Admin'" [sub_label]="'Live Proctor - Detail'"></app-header>

<div class="p-6 flex flex-col gap-6">

  <!-- Top card: video + right panel -->
  <div class="bg-white shadow-lg rounded-lg overflow-hidden flex gap-2 items-stretch p-2" style="height: calc(100vh - 250px);">

    <!-- Video Panel -->
    <div class="relative rounded-lg overflow-hidden bg-black" style="flex:1; min-height:480px">

      <video #mainVideoEl autoplay muted playsinline class="w-full h-full object-cover"></video>

      <div *ngIf="!stream_connected" class="absolute inset-0 flex flex-col items-center justify-center bg-gray-900">
        <i class="bx bx-loader-circle text-gray-400 text-4xl mb-2 animate-spin"></i>
        <p class="text-gray-400 text-sm">Connecting to stream...</p>
      </div>

      <!-- Top-left: fullscreen + name badge -->
      <div class="absolute top-4 left-4 flex items-center gap-2 z-10">
        <button type="button" (click)="open_fullscreen()" class="p-2 rounded-lg flex items-center justify-center text-white" style="background:rgba(30,30,30,0.5)">
          <i class="bx bx-fullscreen text-base"></i>
        </button>
        <div class="px-4 py-2 rounded-lg" style="background:rgba(30,30,30,0.5)">
          <span class="text-white text-sm font-medium uppercase">
            {{ evaluator?.User?.name || 'Loading...' }} ({{ evaluator?.User?.id || evaluator_id }})
          </span>
        </div>
      </div>

      <!-- Top-right: close -->
      <button type="button" (click)="router.navigate(['/ai-admin/live-proctor'])" class="absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center rounded-md" style="background:#f2b6b8">
        <i class="bx bx-x text-lg" style="color:#1e1e1e"></i>
      </button>

      <!-- Bottom tab bar -->
      <div class="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-8 px-6 py-3 rounded-lg z-10" style="background:rgba(30,30,30,0.5)">
        <button type="button" (click)="select_tab('info')" class="w-9 h-9 rounded-full flex items-center justify-center transition-all" [style]="selected_tab==='info' ? 'background:#3f41d1' : 'background:#fff'">
          <i class="bx bx-info-circle text-lg" [style]="selected_tab==='info' ? 'color:#fff' : 'color:#374151'"></i>
        </button>
        <button type="button" (click)="select_tab('ai')" class="w-9 h-9 rounded-full flex items-center justify-center transition-all" [style]="selected_tab==='ai' ? 'background:#3f41d1' : 'background:#fff'">
          <span class="text-xs font-bold" [style]="selected_tab==='ai' ? 'color:#fff' : 'color:#374151'">AI</span>
        </button>
        <button type="button" (click)="select_tab('activity')" class="w-9 h-9 rounded-full flex items-center justify-center transition-all" [style]="selected_tab==='activity' ? 'background:#3f41d1' : 'background:#fff'">
          <i class="bx bx-list-ul text-lg" [style]="selected_tab==='activity' ? 'color:#fff' : 'color:#374151'"></i>
        </button>
        <button *ngIf="gs.user_role_data?.ai_admin_live_proctor_reply_to_evaluator" type="button" (click)="select_tab('messenger')" class="w-9 h-9 rounded-full flex items-center justify-center transition-all" [style]="selected_tab==='messenger' ? 'background:#3f41d1' : 'background:#fff'">
          <i class="bx bx-message-rounded text-lg" [style]="selected_tab==='messenger' ? 'color:#fff' : 'color:#374151'"></i>
        </button>
      </div>
    </div>

    <!-- Right Panel -->
    <div class="flex-shrink-0 flex flex-col overflow-hidden rounded-lg bg-white border" style="width:432px; border-color:rgba(30,30,30,0.16)">

      <ng-container [ngSwitch]="selected_tab">

        <!-- CANDIDATE PROFILE -->
        <ng-container *ngSwitchCase="'info'">
          <div class="bg-[#3f41d1] px-6 py-4 flex items-center flex-shrink-0" style="box-shadow:0px 2px 6px rgba(0,0,0,0.12)">
            <span class="text-white font-medium text-sm uppercase flex-1">Candidate Profile</span>
          </div>

          <div class="flex-1 overflow-y-auto p-4 flex flex-col gap-6">

            <!-- Photo + ID -->
            <div class="flex gap-4 items-start">
              <div class="flex-1 flex flex-col gap-1.5">
                <p class="text-[#1e1e1e] text-sm font-semibold uppercase">Photo</p>
                <div class="w-full aspect-video bg-gray-100 overflow-hidden flex items-center justify-center">
                  <img *ngIf="evaluator?.User?.image" [src]="get_image_url(evaluator.User.image)" alt="Photo" class="w-full h-full object-cover object-top" />
                  <div *ngIf="!evaluator?.User?.image" class="flex flex-col items-center gap-1">
                    <i class="bx bx-user text-gray-300 text-3xl"></i>
                    <p class="text-xs text-gray-400">No Photo</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Info rows -->
            <div class="flex flex-col gap-4">
              <div class="flex items-center gap-6">
                <span class="font-semibold text-sm text-[#1e1e1e] flex-shrink-0" style="width:130px">Name :</span>
                <span class="text-sm text-[#1e1e1e]">
                  {{ evaluator?.User?.name ? (evaluator.User.name + ' (' + (evaluator?.User?.id || evaluator_id) + ')') : '—' }}
                </span>
              </div>
              <div class="flex items-center gap-6">
                <span class="font-semibold text-sm text-[#1e1e1e] flex-shrink-0" style="width:130px">Role :</span>
                <span class="text-sm text-[#1e1e1e]">{{ evaluator?.User?.Role?.name || '—' }}</span>
              </div>
              <div class="flex items-center gap-6">
                <span class="font-semibold text-sm text-[#1e1e1e] flex-shrink-0" style="width:130px">Online Duration :</span>
                <span class="text-sm text-[#1e1e1e]">{{ evaluator?.online_duration || '—' }}</span>
              </div>
              <div class="flex items-center gap-6">
                <span class="font-semibold text-sm text-[#1e1e1e] flex-shrink-0" style="width:130px">Mobile :</span>
                <span class="text-sm text-[#1e1e1e]">{{ evaluator?.User?.contact ? '+91-' + evaluator.User.contact : '—' }}</span>
              </div>
              <div class="flex items-center gap-6">
                <span class="font-semibold text-sm text-[#1e1e1e] flex-shrink-0" style="width:130px">Email :</span>
                <span class="text-sm text-[#1e1e1e] break-all">{{ evaluator?.User?.email || '—' }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- AI TRIGGER -->
        <ng-container *ngSwitchCase="'ai'">
          <div class="bg-[#3f41d1] px-6 py-4 flex items-center justify-between flex-shrink-0">
            <span class="text-white font-medium text-sm uppercase">AI Trigger</span>
            <button type="button" (click)="download_ai_triggers()" class="text-white">
              <i class="bx bx-download text-lg"></i>
            </button>
          </div>
          <div class="flex-1 overflow-y-auto p-3 flex flex-col gap-3">
            <!-- <div *ngFor="let trigger of ai_triggers" class="overflow-hidden">
              {{ trigger | json }}
              <div class="flex items-center justify-between px-1 py-2">
                <span class="flex items-center gap-1.5 text-orange-500 text-xs font-semibold uppercase">
                  <i class="bx bx-error text-sm"></i>
                  {{ trigger }}
                </span>
                <span class="text-gray-400 text-xs flex-shrink-0">{{ format_time(trigger.triggered_at || trigger.created_at) }}</span>
              </div>
              <div class="rounded-lg overflow-hidden">
                <img *ngIf="trigger.image_url || trigger.image_path || trigger.captured_image" [src]="get_image_url(trigger.image_url || trigger.image_path || trigger.captured_image)" alt="Trigger capture" class="w-full object-cover" />
              </div>
            </div> -->
            @for (item of ai_triggers; track $index) {
            <div class="flex items-center justify-between px-1 py-2">
              <span class="flex items-center gap-1.5 text-orange-500 text-xs font-semibold uppercase">
                <i class="bx bx-error text-sm"></i>
                {{ item?.trigger_label }}
              </span>
              <span class="text-orange-500 text-xs  flex-shrink-0">{{ item?.triggered_at | date:'h:mm a' }}</span>
            </div>

            <img [src]="item?.image_url" alt="Trigger capture" class="w-full h-56 rounded-lg object-cover" />

            }
            <div *ngIf=" ai_triggers.length===0" class="flex flex-col items-center justify-center py-10 text-gray-400">
              <i class="bx bx-check-shield text-4xl mb-2"></i>
              <p class="text-xs">No AI triggers found</p>
            </div>
          </div>
        </ng-container>

        <!-- ACTIVITY LOG -->
        <ng-container *ngSwitchCase="'activity'">
          <div class="bg-[#3f41d1] px-6 py-4 flex items-center justify-between flex-shrink-0">
            <span class="text-white font-medium text-sm uppercase">Activity Log</span>
            <button type="button" (click)="download_activity_log()" class="text-white">
              <i class="bx bx-download text-lg"></i>
            </button>
          </div>
          <div class="flex-1 overflow-y-auto p-3 flex flex-col gap-2">
            <div *ngFor="let log of activity_logs" class="flex items-start gap-2 py-2 border-b border-gray-100 last:border-0">
              <div class="flex-1">
                <p *ngIf="log.is_ai" class="text-orange-500 text-[13px] font-normal flex items-center gap-2">
                  <i class="bx bx-alert-triangle"></i> {{ log.description }}
                  <!-- <i class="bx bx-error-circle"></i> {{ log | json}} -->
                </p>
                <p *ngIf="!log.is_ai" class="text-gray-800 text-[13px]">{{ log.text || log.activity }}</p>
                <p *ngIf="log.sub_text && !log.is_ai" class="text-gray-400 text-xs mt-0.5">{{ log.sub_text }}</p>
              </div>
              <span [class]="log.is_ai ? 'text-orange-400 text-xs flex-shrink-0' : 'text-gray-400 text-xs flex-shrink-0'">
                {{ log.timestamp | date:'h:mm a' }}
              </span>
            </div>
            <div *ngIf="activity_logs.length === 0" class="flex flex-col items-center justify-center py-10 text-gray-400">
              <i class="bx bx-history text-4xl mb-2"></i>
              <p class="text-xs">No activity logs found</p>
            </div>
          </div>
        </ng-container>

        <!-- MESSENGER -->
        <ng-container *ngSwitchCase="'messenger'">

          <!-- Header: evaluator name + ID -->
          <div class="bg-[#3f41d1] px-6 py-4 flex-shrink-0">
            <p class="text-white font-bold text-base uppercase tracking-wide">
              {{ evaluator?.User?.name || 'Evaluator' }} ({{ evaluator?.User?.id || evaluator_id }})
            </p>
          </div>

          <!-- Full lavender bg wrapper -->
          <div class="flex-1 flex flex-col overflow-hidden" style="background:#EAEBF8; min-height:0">

            <!-- Messages scroll -->
            <div class="flex-1 overflow-y-auto px-4 py-5 flex flex-col gap-3" style="min-height:0">
              <ng-container *ngFor="let msg of messages">

                <!-- Admin / Proctor sent — bubble + avatar on RIGHT -->
                <div *ngIf="msg.sender_type === 'admin' || msg.sender_type === 'proctor'" class="flex items-end justify-end gap-2">
                  <div class="px-4 py-3 text-[#1e1e1e] text-sm leading-relaxed" style="background:#C8C9EE; border-radius:20px 20px 20px 20px; max-width:75%">
                    {{ msg.message }}
                  </div>
                  <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-primary text-xs font-semibold" style="background: #CCCCF3">
                    {{ (gs.user_data?.name || 'P').charAt(0).toUpperCase() }}
                  </div>
                </div>

                <!-- Evaluator received — bubble on LEFT -->
                <div *ngIf="msg.sender_type !== 'admin' && msg.sender_type !== 'proctor'" class="flex items-end justify-end gap-2">
                  <div class="px-4 py-3 text-[#1e1e1e] text-sm leading-relaxed" style="background:#D8D9EF; border-radius:20px 20px 20px 20px; max-width:75%">
                    {{ msg.message }}
                  </div>
                </div>

              </ng-container>

              <div *ngIf="messages.length === 0" class="flex flex-col items-center justify-center py-10" style="color:#9FA2D3">
                <i class="bx bx-message text-4xl mb-2"></i>
                <p class="text-xs">No messages yet</p>
              </div>
            </div>

            <!-- Input pill -->
            <div *ngIf="gs.user_role_data?.ai_admin_live_proctor_reply_to_evaluator" class="px-4 pb-5 pt-2 flex-shrink-0">
              <div class="flex items-center gap-3 bg-white rounded-full px-5" style="border:1.5px solid #3f41d1; height:52px">
                <input type="text" [(ngModel)]="new_message" (keydown.enter)="send_message()" placeholder="" class="flex-1 bg-transparent text-sm focus:outline-none text-[#1e1e1e] placeholder-gray-400" />
                <button type="button" (click)="send_message()" class="flex items-center justify-center flex-shrink-0 text-[#3f41d1] hover:opacity-70 transition-opacity">
                  <i class="bx bx-send text-xl"></i>
                </button>
              </div>
            </div>

          </div>
        </ng-container>

      </ng-container>
    </div>
  </div>

  <!-- Carousel -->
  <div class="relative flex items-center px-4">
    <button type="button" (click)="scroll_carousel(-1)" class="absolute left-[-12px] z-10 w-9 h-9 flex items-center justify-center rounded-full text-white flex-shrink-0" style="background:#3f41d1; box-shadow:4px 4px 8px 0px rgba(0,0,0,0.23)">
      <i class="bx bx-caret-left text-xl"></i>
    </button>

    <div #carouselEl class="flex gap-6 overflow-x-hidden scroll-smooth w-full">
      <div *ngFor="let item of carousel_items" class="relative flex-shrink-0 flex flex-col gap-2 cursor-pointer" style="flex:1; min-width:0; max-width:220px" (click)="navigate_to_evaluator(get_carousel_user_id(item))">

        <div class="w-full aspect-video overflow-hidden relative bg-gray-900" style="box-shadow:4px 4px 8px 0px rgba(0,0,0,0.23)">
          <video [id]="'carousel-video-' + get_carousel_user_id(item)" autoplay muted playsinline class="w-full h-full object-cover"></video>
          <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
            <!-- <i class="bx bx-video text-gray-600 text-2xl"></i> -->
          </div>
        </div>

        <p class="text-[#1e1e1e] text-xs uppercase truncate">
          {{ get_carousel_name(item) }} ({{ get_carousel_user_id(item) }})
        </p>
      </div>

      <div *ngIf="carousel_items.length === 0" class="flex items-center px-3 text-gray-400 text-sm py-8">
        No other active sessions
      </div>
    </div>

    <button type="button" (click)="scroll_carousel(1)" class="absolute right-[-12px] z-10 w-9 h-9 flex items-center justify-center rounded-full text-white flex-shrink-0" style="background:#3f41d1; box-shadow:4px 4px 8px 0px rgba(0,0,0,0.23)">
      <i class="bx bx-caret-right text-xl"></i>
    </button>
  </div>

</div>

<!-- Fullscreen overlay -->
<div *ngIf="is_fullscreen" class="fixed inset-0 z-50 bg-black flex items-center justify-center">
  <div class="absolute top-4 left-4 flex items-center gap-2 z-10">
    <button type="button" (click)="close_fullscreen()" class="p-2 rounded-lg flex items-center justify-center text-white" style="background:rgba(30,30,30,0.5)">
      <i class="bx bx-exit-fullscreen"></i>
    </button>
    <div class="px-4 py-2 rounded-lg" style="background:rgba(30,30,30,0.5)">
      <span class="text-white text-sm font-medium uppercase">
        {{ evaluator?.User?.name }} ({{ evaluator?.User?.id || evaluator_id }})
      </span>
    </div>
  </div>
  <button type="button" (click)="close_fullscreen()" class="absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center rounded-md" style="background:#f2b6b8">
    <i class="bx bx-x text-lg" style="color:#1e1e1e"></i>
  </button>
  <video #fullscreenVideoEl autoplay muted playsinline class="w-full h-full object-contain"></video>
</div>